function paramsToObject(urlSearchParams) {
    const result = {};
    for (const [key, value] of urlSearchParams.entries()) {
        result[key] = value;
    }
    return result;
}
function getURLParams() {
    const url = window.location.href.toString();
    const separatorChar = url.indexOf('#') >= 0 ? '#' : '?';
    if (url.includes(separatorChar)) {
        const searchParamsStr = url.substring(url.indexOf(separatorChar) + 1);
        const params = utils.paramsToObject(new URLSearchParams(searchParamsStr));
        return params;
    }
    else {
        return {};
    }
}
function setLocalStorage(key, value) {
    try {
        const serializedValue = JSON.stringify(value);
        localStorage.setItem(key, serializedValue);
    }
    catch (error) {
        console.error('Error saving to localStorage:', error);
    }
}
function getLocalStorage(key, defaultValue) {
    try {
        const item = localStorage.getItem(key);
        if (item === null) {
            return defaultValue;
        }
        return JSON.parse(item);
    }
    catch (error) {
        console.error('Error reading from localStorage:', error);
        return defaultValue;
    }
}
function removeLocalStorage(key) {
    try {
        localStorage.removeItem(key);
    }
    catch (error) {
        console.error('Error removing from localStorage:', error);
    }
}
const utils = {
    paramsToObject,
    getURLParams,
    setLocalStorage,
    getLocalStorage,
    removeLocalStorage,
};
export { utils };
